import { Div, DivProps, Heading, P } from '@kizi/core-components';
import { IconV2 as Icon } from '@kizi/shared-components';
import React from 'react';
import { useField } from '@kizi/comparator-core';

export interface UspProps extends DivProps {
  title: string;
  items: string[];
  icon?: string;
  iconSize?: number;
  iconVerticalAlignment?: 'start' | 'center';
  bottomText?: string;
}

export const Usp: React.FC<UspProps> = React.forwardRef<
  HTMLDivElement,
  UspProps
>(
  (
    {
      title,
      items,
      icon = 'check',
      iconSize = 28,
      iconVerticalAlignment = 'center',
      bottomText,
      ...divProps
    },
    ref
  ) => {
    const _items = items.length > 9 ? items.slice(0, 9) : [...items];
    const line = (text: string, key: number) => {
      return (
        <Div
          display="grid"
          gridTemplateColumns={`${iconSize}px auto`}
          gridGap={2}
          key={`benefit-${key}`}
          alignItems={iconVerticalAlignment}
          variant={
            iconVerticalAlignment == 'start'
              ? 'uspParagraphContainerTop'
              : 'uspParagraphContainer'
          }
        >
          <Icon
            data-testid={`icon-name-${icon}`}
            name={icon}
            mr={1}
            variant="success"
            size={iconSize}
          />
          <P variant={iconVerticalAlignment == 'start' ? 'uspParagraph' : ''}>
            {text}
          </P>
        </Div>
      );
    };

    const bottomTextHtml = bottomText ? (
      <P mt={3} fontSize={2} color="second.0">
        {bottomText}
      </P>
    ) : null;

    return (
      <Div variant="secondaryCard" ref={ref} {...divProps}>
        <Heading variant="H4" as="h4" color="white" mb={4} mt="0">
          {title}
        </Heading>
        {_items.map((text, key) => line(text, key))}
        {bottomTextHtml}
      </Div>
    );
  }
);

interface UspFieldWrapperProps extends UspProps {
  _fieldName: string;
}

export const UspFieldWrapper: React.FC<UspFieldWrapperProps> = ({
  _fieldName,
  ...originalUspProps
}) => {
  const fieldFromContext = useField(_fieldName);
  if (!fieldFromContext) return null;

  return fieldFromContext.active ? <Usp {...originalUspProps} /> : null;
};
